import React from 'react'
import { Observable } from 'rxjs'
import { AjaxResponse } from 'rxjs/ajax'
import { getGeneralLedger } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { FinanceApiResponse } from '../../types/finance'

const GeneralLedger = () => {
  const report = useFinanceObservable<Record<string, any>[]>(
    () =>
      getGeneralLedger({}) as any as Observable<
        AjaxResponse<FinanceApiResponse<Record<string, any>[]>>
      >,
  )

  return (
    <ReportTablePage
      title="General Ledger"
      rows={report.data || []}
      isLoading={report.loading}
      columns={[
        {
          name: 'Date',
          selector: (row) =>
            (row.posting_date as string) ||
            (row.document_date as string) ||
            (row.date as string) ||
            '--',
        },
        {
          name: 'Move',
          selector: (row) =>
            (row.move_number as string) || (row.name as string) || '--',
        },
        {
          name: 'Account',
          selector: (row) => (row.account_name as string) || '--',
        },
        {
          name: 'Reference',
          selector: (row) => (row.reference as string) || '--',
        },
        {
          name: 'Debit',
          selector: (row) =>
            (row.debit_base as number) || (row.debit as number) || 0,
        },
        {
          name: 'Credit',
          selector: (row) =>
            (row.credit_base as number) || (row.credit as number) || 0,
        },
      ]}
    />
  )
}

export default GeneralLedger
